<template>


    <app-layout :title="__('Dashboard')">


        <div class="">


            <div class="max-w-9xl mx-auto sm:px-6 lg:px-8">


                <div
                    id="dashboard_layout"
                    style="grid-template-rows: max-content repeat(2, 100px 15px) repeat(2, 310px 15px)"
                    class="grid grid-cols-5">


                    <div class="my-4 row-start-1"
                        style="grid-area: headline;">


                        <h1 class="text-2xl font-nexa text-dark-blue">

                            Dashboard

                        </h1>


                    </div>


                    <MailStatisticsDownloadPopup fetch_url="/exports/newsletters/latest?limit=5" style="grid-area: csv_download;" />


                    <div class="self-center justify-self-end h-[22px]"
                         style="grid-area: filter;">


                        <filter-drop-down
                            :selected="selected_topic"
                            :choices="dropdown_topics"
                            @clicked_item="(choice) => { this.handle_click_dropdown('topic',choice) }"
                        />


                        <filter-drop-down
                            :selected="selected_content_type"
                            :choices="dropdown_content_types"
                            @clicked_item="(choice) => { this.handle_click_dropdown('content_type',choice) }"
                        />


                        <filter-drop-down
                            :selected="selected_language"
                            :choices="dropdown_languages"
                            @clicked_item="(choice) => { this.handle_click_dropdown('language',choice) }"
                        />


                        <filter-drop-down
                            :selected="selected_timeframe"
                            :choices="dropdown_timeframe"
                            @clicked_item="(choice) => { this.handle_click_dropdown('timeframe',choice) }"
                        />


                    </div>


                    <count-widget
                        class="rounded-r-none border-r-1 border-gray-100"
                        title="Subscribers"
                        :count="subscribers.count"
                        :trend="subscribers.trend"
                        icon="user"
                        style="grid-area: subscribers_count;" />


                    <count-widget
                        class="rounded-l-none border-l-1 border-gray-100"
                        title="Unsubscribers"
                        :count="unsubscribers.count"
                        :trend="unsubscribers.trend"
                        :is_trend_opposite=true
                        icon="user-times"
                        style="grid-area: unsubscribers_count;" />


                    <count-widget
                        class="rounded-r-none border-r-1 border-gray-100"
                        title="Mails sent"
                        :count="mails.count"
                        :trend="mails.trend"
                        icon="paper-plane"
                        style="grid-area: mails_sent_count;" />


                    <count-widget
                        class="rounded-l-none border-l-1 border-gray-100"
                        title="Mails bounced"
                        :count="mails_bounced.count"
                        :trend="mails_bounced.trend"
                        :is_trend_opposite=true
                        icon="undo-alt"
                        style="grid-area: mails_bounced_count;" />


                    <count-widget
                        class="rounded-r-none border-r-1 border-gray-100"
                        title="Opens"
                        :count="opens.count"
                        :trend="opens.trend"
                        icon="envelope-open"
                        style="grid-area: opens_count;" />


                    <count-widget
                        class="rounded-l-none border-l-1 border-gray-100"
                        title="Open rate"
                        :count="opens.count_rate"
                        value_type="%"
                        :trend="opens.trend_rate"
                        icon="envelope-open"
                        style="grid-area: open_percent;" />


                    <count-widget
                        class="rounded-r-none border-r-1 border-gray-100"
                        title="Clicks"
                        :count="clicks.count"
                        :trend="clicks.trend"
                        icon="bullseye-pointer"
                        icon_type="far"
                        style="grid-area: clicks_count;" />


                    <count-widget
                        class="rounded-l-none border-l-1 border-gray-100"
                        title="Click rate"
                        :count="clicks.count_rate"
                        value_type="%"
                        :trend="clicks.trend_rate"
                        icon="bullseye-pointer"
                        icon_type="far"
                        style="grid-area: click_percent;" />


                    <list-widget
                        :widget_content="list_content"
                        :options=true
                        columns="5fr 100px"
                        :widget_headers="list_content_headers"
                        style="grid-area: content_widget;" />


                    <list-widget
                        :widget_content="list_topics"
                        columns="5fr 100px"
                        :widget_headers="list_topics_headers"
                        style="grid-area: topics_widget;" />


                    <list-widget
                        :widget_content="list_ads"
                        columns="4.5fr 110px 100px"
                        :widget_headers="list_ads_headers"
                        style="grid-area: ads_widget;" />


                </div>


            </div>


        </div>


    </app-layout>


</template>


<script>

import { defineComponent } from 'vue';

import AppLayout from '../Layouts/AppLayout.vue';

import FilterDropDown from "@/Components/FilterDropDown";

import CountWidget from "@/Components/CountWidget";

import ListWidget from "@/Components/ListWidget";
import MailStatisticsDownloadPopup from "@/Components/MailStatisticsDownloadPopup.vue";

export default defineComponent({

    components: {
        MailStatisticsDownloadPopup,
        ListWidget,
        CountWidget,
        FilterDropDown,
        AppLayout,
    },

    props: {

        subscribers: {
            type: Object,
            default: () => {
                return {
                    count: 22,
                    trend: -10
                }
            }
        },

        unsubscribers: {
            type: Object,
            default: () => {
                return {
                    count: 30,
                    trend: 10
                }
            }
        },

        opens: {
            type: Object,
            default: () => {
                return {
                    count: 17,
                    trend: -404,
                    count_rate: 0.33,
                    trend_rate: 0.45
                }
            }
        },

        clicks: {
            type: Object,
            default: () => {
                return {
                    count: 9,
                    trend: 1,
                    count_rate: 0.1,
                    trend_rate: 0.2
                }
            }
        },

        mails: {
            type: Object,
            default: () => {
                return {
                    count: 220,
                    trend: 420
                }
            }
        },

        mails_bounced: {
            type: Object,
            default: () => {
                return {
                    count: 13,
                    trend: 56
                }
            }
        },

        list_content_headers: {
            type: Array,
            default: () => {
                return [
                    {
                        title: 'Content - Most popular (Top 50)'
                    },
                    {
                        title: 'Clicks'
                    }

                ]

            }

        },


        list_content: {
            type: Array,
            default: () => {
                return [
                    {
                        title: "The Nordic Council's environmental award",
                        clicks: 2500
                    },
                    {
                        title: "Ny rapport: Erhvervslivet i Norden efterspørger mere politisk...",
                        clicks: 2500
                    },
                    {
                        title: "Grænsehindringsrådet får styrket mandat i krisetider",
                        clicks: 2500
                    },
                    {
                        title: "Velfærdsøkonomi i en COVID-19 tid",
                        clicks: 2500
                    },
                    {
                        title: "Hun bliver ny kommunikationschef for det nordiske samarbejde",
                        clicks: 2500
                    },
                    {
                        title: "The Nordic Council's environmental award",
                        clicks: 2500
                    },
                    {
                        title: "Ny rapport: Erhvervslivet i Norden efterspørger mere politisk...",
                        clicks: 2500
                    },
                    {
                        title: "Grænsehindringsrådet får styrket mandat i krisetider",
                        clicks: 2500
                    },
                    {
                        title: "Velfærdsøkonomi i en COVID-19 tid",
                        clicks: 2500
                    },
                    {
                        title: "Hun bliver ny kommunikationschef for det nordiske samarbejde",
                        clicks: 2500
                    },
                    {
                        title: "The Nordic Council's environmental award",
                        clicks: 2500
                    },
                    {
                        title: "Ny rapport: Erhvervslivet i Norden efterspørger mere politisk...",
                        clicks: 2500
                    },
                    {
                        title: "Grænsehindringsrådet får styrket mandat i krisetider",
                        clicks: 2500
                    },
                    {
                        title: "Velfærdsøkonomi i en COVID-19 tid",
                        clicks: 2500
                    },
                    {
                        title: "Hun bliver ny kommunikationschef for det nordiske samarbejde",
                        clicks: 2500
                    },
                    {
                        title: "The Nordic Council's environmental award",
                        clicks: 2500
                    },
                    {
                        title: "Ny rapport: Erhvervslivet i Norden efterspørger mere politisk...",
                        clicks: 2500
                    },
                    {
                        title: "Grænsehindringsrådet får styrket mandat i krisetider",
                        clicks: 2500
                    },
                    {
                        title: "Velfærdsøkonomi i en COVID-19 tid",
                        clicks: 2500
                    },
                    {
                        title: "Hun bliver ny kommunikationschef for det nordiske samarbejde",
                        clicks: 2500
                    },

                ];

            }

        },


        list_topics_headers: {
            type: Array,
            default: () => {
                return [
                    {
                        title: "Most popular topics"
                    },
                    {
                        title: "Clicks"
                    }

                ];

            }

        },


        list_topics: {
            type: Array,
            default: () => {
                return [
                    {
                        title: 'Environment and Climate',
                        clicks: 2500
                    },
                    {
                        title: 'Culture, Leisure and Media',
                        clicks: 2500
                    },
                    {
                        title: 'Education and Research',
                        clicks: 2500
                    },
                    {
                        title: 'Economy, Business and Working Life',
                        clicks: 2500
                    },
                    {
                        title: 'Countries and Regions',
                        clicks: 2500
                    }

                ]

            }

        },


        list_ads_headers: {
            type: Array,
            default: () => {
                return [
                    {
                        title: "Ads - Most popular",
                    },
                    {
                        title: "Sent to",
                    },
                    {
                        title: "Clicks",
                    }

                ]

            }

        },

        list_ads: {
            type: Array,
            default: () => {
                return [
                    {
                        title: 'Den Nordiske miljøstafet',
                        sent_to: 17400,
                        clicks: 504
                    },
                    {
                        title: 'Formanskab',
                        sent_to: 17400,
                        clicks: 420
                    },
                    {
                        title: 'Præsidentskab',
                        sent_to: 17400,
                        clicks: 2500
                    },
                    {
                        title: 'Fakta om Nordiske lande',
                        sent_to: 17400,
                        clicks: 2500
                    },
                    {
                        title: 'COP26: Chosing green',
                        sent_to: 17400,
                        clicks: 2500
                    },

                ]

            }

        },


        selected_topic: {
            type: Object,
            default: () => {
                return {
                    id: 0,
                    name: 'All Topics'
                }
            }
        },

        dropdown_topics: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Countries and Regions',
                    },
                    {
                        id: 2,
                        name: 'Culture, Leisure and Media',
                    },
                    {
                        id: 3,
                        name: 'Legislation and Justice',
                    },
                    {
                        id: 4,
                        name: 'Environment and Climate',
                    },
                    {
                        id: 5,
                        name: 'The Nordic Region and the Surrounding World'
                    },
                    {
                        id: 6,
                        name: 'Education and Research'
                    },
                    {
                        id: 7,
                        name: 'Welfare and Gender Equality'
                    },
                    {
                        id: 8,
                        name: 'Economy, Business and Working Life'
                    },
                    {
                        id: 9,
                        name: 'Nordic Council prizes'
                    },
                    {
                        id: 10,
                        name: 'Nordic Council sessions'
                    }

                ]

            },

        },


        selected_content_type: {
            type: Object,
            default: () => {
                return {
                    id: 0,
                    name: 'All Types'
                }
            }
        },

        dropdown_content_types: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'News',
                    },
                    {
                        id: 2,
                        name: 'Calendar',
                    },
                    {
                        id: 3,
                        name: 'Funding',
                    },
                    {
                        id: 4,
                        name: 'Publications',
                    },

                ]

            },

        },


        selected_language: {
            type: Object,
            default: () => {
                return {
                    id: 0,
                    name: 'All Languages'
                }
            }
        },

        dropdown_languages: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'English',
                    },
                    {
                        id: 2,
                        name: 'Danish',
                    },
                    {
                        id: 3,
                        name: 'Swedish',
                    },
                    {
                        id: 4,
                        name: 'Norwegian',
                    },
                    {
                        id: 5,
                        name: 'Finnish'
                    },
                    {
                        id: 6,
                        name: 'Icelandic',
                    },

                ]

            },

        },


        selected_timeframe: {
            type: Object,
            default: () => {
                return {
                    id: 0,
                    name: 'Last 30 days'
                }
            }
        },

        dropdown_timeframe: {
            type: Array,
            default: () => {
                return [
                    {
                        id: 1,
                        name: 'Last 60 days'
                    },
                    {
                        id: 2,
                        name: 'Last 365 days'
                    },
                    {
                        id: 3,
                        name: 'Today'
                    },
                    {
                        id: 4,
                        name: 'Month to date'
                    },
                    {
                        id: 5,
                        name: 'Quarter to date'
                    },
                    {
                        id: 6,
                        name: 'Year to date'
                    },
                    {
                        id: 7,
                        name: 'Total'
                    },

                ]

            },

        },

    },


    computed: {


    },


    methods: {

        handle_status(status) {

            alert(status);

        },

        handle_click_dropdown(field, choice) {

            let
                parameters = this.route().params
            ;

            parameters[field] = choice.id

            this.$inertia.visit(
                this.route('dashboard', parameters)
            );

        }

    },

})


</script>


<style>


#dashboard_layout {
    grid-template-columns: 1fr 1fr 15px 1fr 1fr;
    grid-template-areas:
        "headline csv_download filter filter filter"
        "subscribers_count unsubscribers_count . mails_sent_count mails_bounced_count"
        ". . . . ."
        "opens_count open_percent . clicks_count click_percent"
        ". . . . ."
        "content_widget content_widget . topics_widget topics_widget"
        "content_widget content_widget . . ."
        "content_widget content_widget . ads_widget ads_widget"
    ;
}


</style>
